import { Injectable } from '@angular/core';
import { Usuario } from '../_classes/usuario';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { URL } from '../_mocks/url';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type' : 'application/json' })
};

@Injectable()
export class LoginService {

  private urlLogin = URL + 'usuario/login';

  constructor(
    private http: HttpClient
  ) { }

  login (usuario: Usuario): Observable<Response> {
    return this.http.post<Response>(
      this.urlLogin,
      usuario, {
        headers: new HttpHeaders({'Content-Type': 'application/json'}),
        observe: 'response' as 'body',
        responseType: 'json'
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/login.service.ts